"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _angieslistAppPlatform = require("angieslist-app-platform");
var serviceProviderGatewayService = {
  getAssociateContactPreferences: function getAssociateContactPreferences(userId) {
    return _angieslistAppPlatform.httpClient.get("/gateway/service-provider/v1/associate/".concat(userId, "/preferences"));
  },
  saveAssociateContactPreferences: function saveAssociateContactPreferences(data) {
    return _angieslistAppPlatform.httpClient.post('/gateway/service-provider/v1/associate/preferences', {
      body: data
    });
  },
  getAssociateContactPreferencesByEmail: function getAssociateContactPreferencesByEmail(email, apiToken, serviceProviderId) {
    var serviceProviderIdQueryString = serviceProviderId ? '&serviceProviderId=' + serviceProviderId : '';
    return _angieslistAppPlatform.httpClient.get("/gateway/service-provider/v1/associate/preferences?email=".concat(email).concat(serviceProviderIdQueryString), {
      headers: {
        Authorization: apiToken
      }
    });
  },
  saveAssociateContactPreferencesByEmail: function saveAssociateContactPreferencesByEmail(_ref) {
    var email = _ref.email,
      apiToken = _ref.apiToken,
      preferences = _ref.preferences,
      serviceProviderId = _ref.serviceProviderId;
    return _angieslistAppPlatform.httpClient.post('/gateway/service-provider/v1/associate/preferences/unauth', {
      body: {
        email: email,
        preferences: preferences,
        serviceProviderId: serviceProviderId
      },
      headers: {
        Authorization: apiToken
      }
    });
  }
};
var _default = exports["default"] = serviceProviderGatewayService;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/services/serviceProviderGatewayService.js
// module id = 4294
// module chunks = 9